import { useAxios, useSubjectId } from '@healthblocks-io/core'
import { useCallback } from 'react'

import type { PaymentStatusResponse } from '@/modules/payment/types/payment.types'

export function usePayment() {
  const subjectId = useSubjectId()
  const axios = useAxios()

  /**
   * Check the status of a payment
   * @param paymentId - The external id of the payment
   * @returns The status of the payment
   */
  const checkPaymentStatus = useCallback(
    (paymentId: string) => {
      return axios.get<PaymentStatusResponse>(`/payment/external/${paymentId}/status?subjectId=${subjectId}`)
    },
    [axios, subjectId],
  )

  const cancelPayment = useCallback(
    (paymentId: string) => {
      return axios.post(`/payment/external/${paymentId}/cancel?subjectId=${subjectId}`)
    },
    [axios, subjectId],
  )

  return {
    checkPaymentStatus,
    cancelPayment,
  }
}
